import useAuthStore from '@/stores/useAuthStore'

/**
 * True when the current user's company runs in Interventiedesk-only mode and
 * the user has Interventiedesk access. In that mode the content platform is
 * hidden: no Beheer/Platform switch, search bar, budget chip, content menu
 * (themes/articles/experts) or chatbot.
 *
 * Users without Interventiedesk access keep the platform, otherwise they would
 * have nowhere to go.
 */
export const useInterventiedeskOnly = () => {
  const interventiedeskOnly = useAuthStore((state) => state.interventiedeskOnly)
  const member = useAuthStore((state) => state.user?.companyMember)
  const hasInterventiedeskAccess = !!member?.isHrManager || !!member?.isAdmin || !!member?.isOwner
  return !!interventiedeskOnly && hasInterventiedeskAccess
}

export default useInterventiedeskOnly
